import React, { useEffect, useState } from 'react';
import ActionModal from 'components/common/modals/ActionModal';
import { useRootStore } from 'store/rootStore';
import { Select } from '@insurancemenu/imenu-components-lib';
import { ModalType } from 'global/utils/ModalsHelper';
import { observer } from 'mobx-react-lite';
import { GenerationStep, Policy } from 'types/policyService';
import { createStyles } from './styles';

export interface UpdatePolicyStepModalProps {
  policy: Policy | null;
  isModalOpen: boolean;
}

const UpdatePolicyStepModal = observer(({ policy, isModalOpen }: UpdatePolicyStepModalProps): JSX.Element => {
  const classes = createStyles();
  const {
    policyDashboardStore: { modalLoading, getStepOptions, updatePolicyStep, closeModal },
  } = useRootStore();

  const [step, setStep] = useState(policy?.generationStep || GenerationStep.NOT_STARTED);

  useEffect(() => {
    if (policy?.generationStep && policy?.generationStep !== step) {
      setStep(policy?.generationStep);
    }
  }, [policy?.generationStep]);

  const onStepUpdate = async (): Promise<void> => {
    if (policy?.id) await updatePolicyStep(policy.id, step);
    closeModal();
  };

  const modalContent = (
    <Select
      label="Generation Step"
      name="step"
      options={getStepOptions()}
      onChange={(e: React.ChangeEvent<HTMLSelectElement>): void => {
        setStep(e.target.value as GenerationStep);
      }}
      value={step}
      width="30rem"
      className={classes.stepField}
    />
  );

  return (
    <div>
      <ActionModal
        show={isModalOpen}
        title="Update Policy Step"
        subtitle={
          <p className={classes.subtitle}>
            <span>
              Please select one of the available steps to update the policy
              <b className={classes.selectedFile}>{policy?.id || ''}</b>
            </span>
          </p>
        }
        modalType={ModalType.NOTIFICATION}
        closeButtonText="Cancel"
        onClose={closeModal}
        actionButtonText="Update Step"
        onAction={onStepUpdate}
        loading={modalLoading}
        modalContent={modalContent}
      />
    </div>
  );
});

export default UpdatePolicyStepModal;
